import { create } from 'zustand'
import type { IResponseGetPlans } from '../../../interfaces/src'

interface PlansState {
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  plans: IResponseGetPlans | null
  setPlans: (plans: IResponseGetPlans) => void
  isError: boolean
  setIsError: (isError: boolean) => void
}

export const usePlanStore = create<PlansState>()((set) => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  plans: null,
  setPlans: (plans: IResponseGetPlans) => set({ plans }),
  isError: false,
  setIsError: (isError: boolean) => set({ isError })
}))
